import { ReactComponent as Info } from '@public/icons/info.svg';
import Icon from '../atoms/Icon';

const IconInfo = (props) => <Icon as={Info} {...props} />;

IconInfo.propTypes = Icon.propTypes;

export default IconInfo;
